export default function Delivery() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.70984 8.30664L9.77288 12.4319"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.84973 8.6582L7.52025 12.5949"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.57 7.95511L10.9879 12.344"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4301 7.60395L13.2406 12.1814"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1317 7.55297C18.2815 7.54649 18.4225 7.4643 18.5254 7.32353C18.5685 7.2657 18.5976 7.19229 18.6092 7.11228C18.6207 7.03227 18.6141 6.94915 18.5902 6.87308C17.3893 3.18008 13.7712 1.00608 9.69764 1.30067C5.62402 1.59527 2.39247 4.26354 1.61534 8.10066C1.60023 8.17955 1.60305 8.26294 1.62348 8.34064C1.6439 8.41834 1.68104 8.48696 1.73033 8.53811C1.84815 8.66301 1.99731 8.72423 2.14665 8.70896L18.1317 7.55297Z"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.52471 20.9659C3.13156 20.9659 2.0129 21.0243 1.50875 20.5115C1.00461 19.9987 0.679611 18.0988 1.00617 17.4348C1.33274 16.7709 2.51866 16.4093 3.52691 15.8965L4.30501 15.4281L4.3963 15.3482C6.06347 13.9638 7.99273 13.0852 10.0478 12.8722C11.8488 12.6858 14.0271 12.9787 16.2688 14.3897L17.6705 15.3216C17.6705 15.3216 20.5 16 22.9013 17.4781C23 19.5 23.2 21.4 20 21"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M4.03169 15.3837C4.03169 15.3837 5.74393 16.4093 6.55118 16.4093C7.35842 16.4093 13.684 16.2798 13.684 16.2798C15.0716 16.2798 16.4308 15.9337 17.6699 15.2947L17.7157 15.2681"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M7 21H16"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <circle cx="5.85" cy="20.85" r="1.85" stroke="#0B0C0E" strokeWidth="1.5" />
      <circle cx="17.85" cy="20.85" r="1.85" stroke="#0B0C0E" strokeWidth="1.5" />
    </svg>
  );
}
